import React from 'react';
import { useEffect } from "react";
import { useState } from 'react';
import axios from "axios";
import { useNavigate } from 'react-router-dom';

import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';

import PreShowResponseInterface from "../interfaces/preShowResponseInterface";
import { stringify } from 'querystring';

import Cookies from "js-cookie";
import { v4 as uuid } from "uuid";


export default function PreshowQuestions() {

  const queryParameters = new URLSearchParams(window.location.search)
  const sID = queryParameters.get("showID") ?? "undefined"

  // Get (or create) unique ID for this patron
  const [userID2, setUserID2] = useState("initializing");
  if (userID2 == "initializing") {
    const c = Cookies.get("UserID2");
    if (c == null) {
      // generate  unique random identifier
      const unique_id = uuid();
      Cookies.set("UserID2", unique_id, { expires: 7, path: "/" });
      setUserID2(unique_id);
    } else {
      setUserID2(c);
    }
  }

  const navigate = useNavigate();

  function submitForm(techcontrol,wildprediction) {

    var s;
    
    const preShowResponse: PreShowResponseInterface = { 
      showID: sID,
      techControl: techcontrol, 
      wildPrediction: wildprediction, 
      userID2: userID2
    };
    console.log("Submitting response: " + sID + ", " + preShowResponse.techControl + ", " + preShowResponse.userID2)

    axios
    .post<PreShowResponseInterface>(process.env.REACT_APP_HOST + "/preshowresponse", preShowResponse)
    .then((response) => {
      s = response.status
      console.log("Response: " + response.status)
      navigate('/voting?showID=' + sID) // Send them to the main page, specifying the showID now... (will this work?)
//      setCurrentBallot(response.data);
    })
    .catch((ex) => {
      const error = "An unexpected error has occurred. Could not submit response: " + ex;
      console.log(error)
    });
    //addVotedIDToStorage(currentBallot.id);
    //setUserInputData('')
    console.log("Submitted response - status: " + s) // will it ever get here? I think so
  }

  useEffect(() => {
    document.title = "DxD Preshow Questions";
  }, []);

  const [radioValue, setRadioValue] = useState('1');

  const [techcontrol, setTechcontrol] = useState('');
  const [wildprediction, setWildprediction] = useState('');
  const [error, setError] = useState('');
  const [status, setStatus] = useState('typing');

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus('submitting');
    try {
      await submitForm(techcontrol,wildprediction);
      setStatus('success');
    } catch (err) {
      setStatus('typing');
      setError('err');
    }
  }

  const handleChange = (val) => {
    setTechcontrol(val); 
    console.log(val);
  }

  function handleTextareaChange(e) {
    setWildprediction(e.target.value);
  }

  return (
    <>
      <p>Before we start, please take a few moments to share some information with us:</p>
      
      <form onSubmit={handleSubmit}>
        <p>
          How much do you control your technology and how much does it control you?
        </p>

        <ToggleButtonGroup type="radio" name="options" value={techcontrol} onChange={handleChange}>
          <ToggleButton id="tg1" value="1">
            <label htmlFor="tg1">I control technology a lot</label><br />
          </ToggleButton>
          <ToggleButton id="tg2" value="2">
            <label htmlFor="tg2">I am generally in control of my technology</label><br />
          </ToggleButton>
          <ToggleButton id="tg3" value="3">
          <label htmlFor="tg3">Technology is generally in control of me</label><br />
          </ToggleButton>
          <ToggleButton id="tg4" value="4">
          <label htmlFor="tg4">Technology controls me a lot<br /></label>
          </ToggleButton>
        </ToggleButtonGroup>

        <br />
        <p>
          Please share a wild prediction about the future of technology:
        </p>
        <textarea
          rows={3}
          cols={30}
          value={wildprediction}
          onChange={handleTextareaChange}
          disabled={status === 'submitting'}
        />
        <br />

        <button disabled={
          wildprediction.length === 0 ||
          status === 'submitting'
        }>
          Submit
        </button>
        {error !== '' &&
          <p className="Error">
            {error}
          </p>
        }
      </form>

    </>
  );
}

